const styles = () => ({
  container: {
    width: '100%',
    height: '90vh',
    padding: '10px',
    position: 'relative',
  },
  videoWrapper: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
  videoPlayer: {
    maxHeight: '80vh',
    maxWidth: '100%',
  },
});

export default styles;
